import React from "react";

export default function CoreValueCard({ icon, title, description, bgClass }) {
  return (
    <div className="p-4 md:w-1/3">
      <div className={`flex rounded-lg h-full  p-8 flex-col 
                      transition-transform transform hover:-translate-y-2 
                      hover:shadow-xl hover:shadow-green-300 ${bgClass}`}>
        <div className="flex items-center mb-3">
          <div className="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-secondary text-white flex-shrink-0">
            {icon}
          </div>
          <h2 className="text-lg title-font font-medium">
            {title}
          </h2>
        </div>
        <div className="flex-grow">
          <p className="leading-relaxed text-sm font-light">{description}</p>
        </div>
      </div>
    </div>
  );
}
